import { login, parseHash } from "../action";
import { setSession, setGrantAccess } from "modules/admin";
import { addAlert, setLoading } from "modules/notification";
import { setSignupSuccessData } from "../slice/signup.slice";
import { getApiLang } from "app/feature/constants";

const sessionLoginMiddleware = ({ getState, dispatch }) => next => action => {
  next(action);

  const { type, payload } = action;

  if (type.includes(login.typePrefix)) {
    switch (type) {
      case login.pending.type:
        next(setLoading({ id: login.typePrefix, state: true }));
        break;

      case login.fulfilled.type:
        localStorage.setItem('session_id', payload.session_id)
        localStorage.setItem('session_expiration', payload.session_expiration)
        dispatch(setSession(payload))
        next(setLoading({ id: login.typePrefix, state: false }));
        break;

      case login.rejected.type:
        const lang = getState().constant.languages;
        next(setLoading({ id: login.typePrefix, state: false }));

        if (payload.code === 'error.ERROR_LOGIN_RATE_LIMITED_TEMPORARY') {
          try {
            const templateMessage = getApiLang(lang, payload.code);

            let minutesValue = 1; // default to 1 min if value is missing
            
            if (payload.data && typeof payload.data === 'object') {
              if (typeof payload.data.remaining_minutes === 'number') {
                // Round up to the next minute (always show at least 1 more minute than actual time)
                minutesValue = Math.ceil(payload.data.remaining_minutes);
              } else if (typeof payload.data.minutes === 'number') {
                // Round up to the next minute
                minutesValue = Math.ceil(payload.data.minutes);
              }
            }

            //Convert to hours if mins >=60
            let finalMessage;
            if (minutesValue >= 60) {
              // Hours roundup
              const hours = Math.ceil(minutesValue / 60);
              const hoursText = hours === 1 ? "hour" : "hours";
              finalMessage = templateMessage
                .replace(/\{minutes\}/g, hours)
                .replace(/minutes/g, hoursText);
            } else {
              const minutesText = minutesValue === 1 ? "minute" : "minutes";
              finalMessage = templateMessage
                .replace(/\{minutes\}/g, minutesValue)
                .replace(/minutes/g, minutesText);
            }
            
            next(
              addAlert({
                severity: "error",
                message: finalMessage
              })
            );
          } catch (error) {
            // Fallback message if anything fails
            next(
              addAlert({
                severity: "error",
                message: "Your account is temporarily locked. Please try again later or contact support."
              })
            );
          }
        } else if (payload.code === 'error.ERROR_LOGIN_RATE_LIMITED_PERMANENT') {
          // Handle permanent lockout message
          next(
            addAlert({
              severity: "error",
              message: getApiLang(lang, payload.code)
            })
          );
        } else {
          // Handle regular error messages
          next(
            addAlert({
              severity: "error",
              message: getApiLang(lang, payload.code)
            })
          );
        }
        break;

      default:
        break;
    }
  }
};

const parseHashMiddleware = ({ getState }) => next => action => {
  next(action);

  const { type, payload } = action;

  switch (type) {
    case parseHash.pending.type:
      next(setLoading({ id: parseHash.typePrefix, state: true }));
      break;

    case parseHash.fulfilled.type:
      const { emailVerified, email, sub } = payload.idTokenPayload;

      if (!emailVerified) next(setSignupSuccessData({ email, id: sub }));

      next(setSession(payload));
      next(setLoading({ id: parseHash.typePrefix, state: false }));

      break;

    case parseHash.rejected.type:
      const lang = getState().constant.languages;
      next(setGrantAccess(false));
      next(setLoading({ id: parseHash.typePrefix, state: false }));
      next(
        addAlert({
          severity: "error",
          message: getApiLang(lang, payload.errorDescription.replace(/\s/g, ''))
        })
      );
      break;

    default:
      break;
  }
};

export default [sessionLoginMiddleware, parseHashMiddleware];
